import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useCart } from "../cart/CartContext";
import { toast } from "react-toastify";
import "./Navbar.css";

export default function Navbar() {
  const { currentUser } = useAuth();
  const { items } = useCart();
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.info("Logged out successfully");
      closeMenu();
      navigate("/");
    } catch (err) {
      console.error(err);
      toast.error("Error logging out");
    }
  };

  const cartCount = items?.reduce((sum, it) => sum + it.quantity, 0) || 0;

  return (
    <nav
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "14px 30px",
        background: "rgba(255,255,255,0.9)",
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      {/* LEFT SIDE */}
      <div style={{ display: "flex", alignItems: "center", gap: "22px" }}>
        <Link
          to="/"
          style={{ ...linkStyle, fontWeight: 700, fontSize: "1.15rem" }}
          onClick={closeMenu}
        >
          Lutology
        </Link>

        {/* Desktop links (unchanged for PC) */}
        <div className="lut-desktop-only" style={{ display: "flex", gap: "22px", alignItems: "center" }}>
          <Link to="/products" style={linkStyle} onClick={closeMenu}>
            Products
          </Link>
          <Link to="/about" style={linkStyle} onClick={closeMenu}>
            About
          </Link>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
        {/* CART */}
        <div style={{ position: "relative" }}>
          <Link
            to="/cart"
            style={{
              ...linkStyle,
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "0.95rem",
            }}
            onClick={closeMenu}
          >
            <span style={{ fontSize: "1.25rem" }}>🛒</span>
            <span className="lut-desktop-only">Cart</span>
          </Link>

          {cartCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-6px",
                right: "-12px",
                background: "#111",
                color: "#fff",
                borderRadius: "50%",
                fontSize: "0.7rem",
                padding: "3px 6px",
                lineHeight: 1,
                boxShadow: "0 0 3px rgba(0,0,0,0.25)",
              }}
            >
              {cartCount}
            </span>
          )}
        </div>

        {/* AUTH (desktop unchanged) */}
        <div className="lut-desktop-only" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {!currentUser ? (
            <>
              <Link to="/login" style={buttonStyleLight} onClick={closeMenu}>
                Login
              </Link>
              <Link to="/signup" style={buttonStyleDark} onClick={closeMenu}>
                Sign Up
              </Link>
            </>
          ) : (
            <>
              <span style={{ color: "#555", fontSize: "0.85rem", marginRight: "4px" }}>
                {currentUser.email}
              </span>

              <button
                onClick={() => {
                  closeMenu();
                  navigate("/my-account");
                }}
                style={buttonStyleLight}
              >
                My Account
              </button>

              <button onClick={handleLogout} style={buttonStyleLight}>
                Logout
              </button>
            </>
          )}
        </div>

        {/* BURGER (mobile only) */}
        <button
          className="lut-mobile-only"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Menu"
          aria-expanded={menuOpen}
          style={{
            border: "1px solid #888",
            background: "transparent",
            borderRadius: "8px",
            padding: "8px 12px",
            cursor: "pointer",
            fontSize: "1rem",
            color: "#333",
          }}
        >
          ☰
        </button>

        {/* MOBILE MENU (only rendered on mobile, but safe anyway) */}
        {menuOpen && (
          <div className="lut-mobile-menu">
            <Link to="/products" className="lut-mobile-link" onClick={closeMenu}>
              Products
            </Link>
            <Link to="/about" className="lut-mobile-link" onClick={closeMenu}>
              About
            </Link>

            <div className="lut-mobile-auth">
              {!currentUser ? (
                <>
                  <Link to="/login" style={buttonStyleLight} onClick={closeMenu}>
                    Login
                  </Link>
                  <Link to="/signup" style={buttonStyleDark} onClick={closeMenu}>
                    Sign Up
                  </Link>
                </>
              ) : (
                <>
                  <div style={{ color: "#555", fontSize: "0.85rem" }}>{currentUser.email}</div>

                  <button
                    onClick={() => {
                      closeMenu();
                      navigate("/my-account");
                    }}
                    style={buttonStyleLight}
                  >
                    My Account
                  </button>

                  <button onClick={handleLogout} style={buttonStyleLight}>
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

// STYLES (כמו שלך)
const linkStyle = {
  color: "#333",
  textDecoration: "none",
  fontWeight: 500,
  transition: "color 0.2s",
};

const buttonStyleDark = {
  background: "linear-gradient(90deg, #222, #444)",
  color: "#fff",
  padding: "8px 14px",
  borderRadius: "8px",
  textDecoration: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
};

const buttonStyleLight = {
  background: "transparent",
  border: "1px solid #888",
  color: "#333",
  padding: "8px 14px",
  borderRadius: "8px",
  textDecoration: "none",
  fontWeight: 500,
  fontSize: "0.9rem",
  cursor: "pointer",
};
